module.exports = __webpack_public_path__ + "files/1e09359b9048968f3fdd1998fd057677.png";